import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const AuthProvider = ({ children }) => {
  const { isAuth, token, user } = useSelector((state) => state.auth);
  return isAuth ? children : <Navigate to="/login" />;
};

export default AuthProvider;
